<template>
  <div>
    <LsModal
      title="Thanks for your request to pause service!"
      track-id="pause_cancel_success_modal"
    >
      <template #body>
        <p>
          All services have been paused for the season. We look forward to servicing you again in
          the spring.
        </p>
      </template>
      <template #footer>
        <LsButton text="ok" track-id="pause_cancel_success_modal-ok" @click="close" />
      </template>
    </LsModal>
  </div>
</template>

<script>
import { LsButton, LsModal } from '@/components/common';

export default {
  name: 'PauseCancelSuccessModal',
  components: {
    LsButton,
    LsModal,
  },
  methods: {
    close() {
      this.$parent.close();
    },
  },
};
</script>

<style lang="scss" scoped></style>
